export default "__VITE_ASSET__NRJmJr7P__"